import React from 'react'

function SkillBox({ skill, icon, alt, link }) {
    return (
        <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            className="flex flex-col items-center justify-center bg-base-100 transition-all duration-300 w-24 h-24 md:w-28 md:h-28 rounded-xl gap-2 hover:shadow-md border border-base-200 hover:border-primary/20"
        >
            <div className="p-2 flex items-center justify-center">
                <img
                    className="w-10 h-10 md:w-12 md:h-12 object-contain"
                    alt={alt}
                    src={icon}
                />
            </div>
            <div className="text-xs md:text-sm font-medium text-center px-1">
                {skill}
            </div>
        </a>
    )
}

export default SkillBox;